import { DataTablePagination, DataTableSearch, Typography, DataTable } from '@ui/components';
import { useTranslation } from 'react-i18next';

import { useInvoiceRecipientsTable } from './use-invoicing-recipients-table';

interface InvoiceRecipientsTableProps {
  invoiceId: string;
}

export const InvoiceRecipientsTable = ({ invoiceId }: InvoiceRecipientsTableProps) => {
  const { t } = useTranslation();

  const { columnsLength, isLoading, table, totalItems } = useInvoiceRecipientsTable({
    invoiceId,
  });

  return (
    <div className="bg-table-background rounded-lg overflow-auto h-full border border-border-default">
      <div className="flex items-center px-4 py-3">
        <Typography variant="labelMediumMedium">
          {t('FILES_REPORTS.INVOICING.RECIPIENTS_TABLE.TITLE')}
        </Typography>

        <div className="ml-auto flex items-center gap-4">
          <DataTablePagination
            pageIndex={table.getState().pagination.pageIndex}
            pageSize={table.getState().pagination.pageSize}
            prevPageDisabled={!table.getCanPreviousPage()}
            nextPageDisabled={!table.getCanNextPage()}
            prevPage={() => table.previousPage()}
            nextPage={() => table.nextPage()}
            totalRows={totalItems ?? 0}
          />
        </div>
      </div>

      <div className="pt-0 p-4">
        <DataTableSearch
          placeholder={t('FILES_REPORTS.INVOICING.RECIPIENTS_TABLE.SEARCH_PLACEHOLDER')}
          value={table.getState().globalFilter}
          onChange={table.setGlobalFilter}
        />
      </div>

      <DataTable
        noResultsComponent={
          <Typography variant="labelMediumBook">
            {t('FILES_REPORTS.INVOICING.RECIPIENTS_TABLE.NO_RESULTS')}
          </Typography>
        }
        columnsLength={columnsLength}
        isLoading={isLoading}
        table={table}
      />
    </div>
  );
};
